<template>
  <div>
    <b-modal
      id="modal-idle"
      v-model="localShowModalIdle"
      title="Истекла сесија"
      @hide="redirectionOnClick"
      hide-footer
    >
      <form @submit.prevent="redirectionOnClick">
        <p>Поштовани, истекла Вам је сесија.</p>
      </form>
      <div>
        <b-button
          variant="default"
          @click="redirectionOnClick"
          class="confirm-button"
        >
          Иди на насловну страну
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const localShowModalIdle = computed({
  get: () => store.state.showModalIdle,
  set: (val) => store.dispatch("setShowModalIdle", val),
});

function redirectionOnClick() {
  window.location.href = "/";
  store.dispatch("setShowModalIdle", false);
}
</script>
<style>
.confirm-button {
  float: right;
  margin-top: 20px;
}
</style>
